export default {
  name: 'vote-banner-ptwc'
}
